import { useSortable } from "@dnd-kit/sortable";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { IconButton } from "@mui/material";

interface DragHandleProps {
  id: string;
  disabled: boolean;
}

export function DragHandle(props: DragHandleProps) {
  const { id, disabled } = props;
  const { attributes, listeners, setNodeRef } = useSortable({
    id,
    disabled,
  });

  return (
    <IconButton
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      disableRipple
      disabled={disabled}
      sx={(theme) => ({
        cursor: disabled ? "default" : "grab",
        "&:active": {
          cursor: "grabbing",
        },
        color: theme.palette.text.secondary,
      })}
    >
      <DragIndicatorIcon />
    </IconButton>
  );
}
